import { useContext } from 'react';
import { CadUniqueChartsDataContext } from '../contexts/CadUniqueChartsDataContext';

export const useCadUniqueChartsDataContext = () => {
    return useContext(CadUniqueChartsDataContext);
};
